__turbopack_context__.v({
  "logo": "companyLogo-module-scss-module__JH3vWa__logo",
});
